import {
  Component,
  EventEmitter,
  Injector,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { FormGroup } from '@angular/forms';
import { BaseComponent } from '@app/shared/base/base-component/base-component.component';
import { ModelField } from '@app/shared/interfaces/front-end-column';
import { DropDownOption } from '@product/shared/models/GlobalInterfaces';

@Component({
  template: ``,
  styles: [],
})
export class BaseProductFieldComponent extends BaseComponent implements OnInit {
  @Input() field: ModelField;
  // private _formGroup: FormGroup;
  // public get formGroup(): FormGroup {
  //   return this._formGroup;
  // }
  // @Input()
  // public set formGroup(value: FormGroup) {
  //   this._formGroup = value;
  //   if (value != null) {
  //     this.formGroupInited();
  //   }
  // }
  @Input() disabled: boolean = false;
  @Input() controlName: string = '';
  _drpMetaData = {};
  @Input() set dropDownsMetaData(dropDownsMetaData: {
    [key: string]: DropDownOption[];
  }) {
    if (dropDownsMetaData == null) {
      this._drpMetaData = this.commonService.dropDownMetaData;
    } else {
      this._drpMetaData = dropDownsMetaData;
    }
  }
  get dropDownsMetaData() {
    return this._drpMetaData;
  }
  @Input() languageId: number = 0;
  @Output() onBlur = new EventEmitter();

  constructor(injector: Injector) {
    super(injector);
  }

  ngOnInit(): void {}
  onFieldBlur(element: any) {
    const value = element?.target?.value;
    this.onBlur.emit(value);
  }

  formGroupInited() {}
}
